import { Component } from '@angular/core';
import { LoaderService } from '@stockcare-services/loader-service/loader.service';
import { Subject } from 'rxjs';
@Component({
  standalone: false,
    selector: 'app-spinning-loader',
    templateUrl: './spinning-loader.component.html',
    styleUrls: ['./spinning-loader.component.scss']
})
export class SpinningLoaderComponent {
    isLoading: Subject<boolean> = this.loaderService.isLoading;
    constructor(private loaderService: LoaderService) {}
}
